module.exports = {
      id: "search-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#search",
      toString: function () {
        return this.url;
      }
    }